import { render, staticRenderFns } from "./preview-size-change-button.vue?vue&type=template&id=535d357e"
import script from "./preview-size-change-button.vue?vue&type=script&lang=js"
export * from "./preview-size-change-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports